import client from './ApiClient';

function getColleague(query) {
  return client(`v1/users`, { method: 'GET', params: query });
}

export { getColleague };
